import { render } from "./LabelSearchSortBar.vue?vue&type=template&id=7d83336b&scoped=true"
import script from "./LabelSearchSortBar.vue?vue&type=script&lang=js"
export * from "./LabelSearchSortBar.vue?vue&type=script&lang=js"

import "./LabelSearchSortBar.vue?vue&type=style&index=0&id=7d83336b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d83336b"]])

export default __exports__